import ENV from "./ENV";

interface IAPIConfig {
    [k: string]: {
        URL: string | Function | any,
        METHOD: "get" | "post" | "delete" | "put" | "patch",
    }
}

const APIConfig: IAPIConfig = {
    //meta start
    PHYSICAL_ACTIVITY_FREQUENCY: {
        URL: ENV.ADMIN_API_URL + "/physicalActivityFrequency",
        METHOD: "get"
    },
    PHYSICAL_ACTIVITY_INTENSITY: {
        URL: ENV.ADMIN_API_URL + "/physicalActivityIntensity",
        METHOD: "get"
    },
    PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT: {
        URL: ENV.ADMIN_API_URL + "/physicalActivityFrequencyForHeartRateImpact",
        METHOD: "get"
    },
    PHYSICAL_ACTIVITY_EXERCISE_CAPACITY: {
        URL: ENV.ADMIN_API_URL + "/physicalActivityExerciseCapacity",
        METHOD: "get"
    },
    PHYSICAL_ACTIVITY_TYPES: {
        URL: ENV.ADMIN_API_URL + "/physicalActivityTypes",
        METHOD: "get"
    },
    WEIGHT_UNITS: {
        URL: ENV.ADMIN_API_URL + "/weightUnits",
        METHOD: "get"
    },
    HEIGHT_UNITS: {
        URL: ENV.ADMIN_API_URL + "/heightUnits",
        METHOD: "get"
    },
    CONSULTATION_DURATION_LIST: {
        URL: ENV.ADMIN_API_URL + "/consultation/duration",
        METHOD: "get"
    },
    GENDER_LIST: {
        URL: ENV.ADMIN_API_URL + "/gender",
        METHOD: "get"
    },
    LANGUAGE_LIST: {
        URL: ENV.ADMIN_API_URL + "/language",
        METHOD: "get"
    },
    PHONE_TYPE_LIST: {
        URL: ENV.ADMIN_API_URL + "/phone/type",
        METHOD: "get"
    },
    EMPLOYMENT_STATUS_LIST: {
        URL: ENV.ADMIN_API_URL + "/employement/status",
        METHOD: "get"
    },
    RELATIONSHIP_LIST: {
        URL: ENV.ADMIN_API_URL + "/relationship",
        METHOD: "get"
    },
    CPT_CODES_LIST: {
        URL: ENV.ADMIN_API_URL + "/cptCodes",
        METHOD: "get"
    },
    MEDICAL_HISTORY_OPTIONS_LIST: {
        URL: ENV.ADMIN_API_URL + "/medicalHistory/question",
        METHOD: "get"
    },
    DOCUMENT_FILE_TYPES: {
        URL: ENV.ADMIN_API_URL + "/documentTypes",
        METHOD: "get"
    },
    DOCUMENT_TYPES_LIST: {
        URL: ENV.ADMIN_API_URL + "/documentFileTypes",
        METHOD: "get"
    },

    SURGICAL_HISTORY_OPTIONS_LIST: {
        URL: ENV.ADMIN_API_URL + "/surgicalHistory/question",
        METHOD: "get"
    },
    MUSCULOSKELETAL_HISTORY_OPTIONS_LIST: {
        URL: ENV.ADMIN_API_URL + "/musculoSkeletal/question",
        METHOD: "get"
    },
    SOCIAL_MEDIA_PLATFORM_LIST: {
        URL: ENV.ADMIN_API_URL + "/socialMedia",
        METHOD: "get"
    },
    REFERRAL_TYPE_LIST: {
        URL: ENV.ADMIN_API_URL + "/referral",
        METHOD: "get"
    },
    COMMUNICATION_MODE_TYPE_LIST: {
        URL: ENV.ADMIN_API_URL + "/communication/type",
        METHOD: "get"
    },
    BODY_PART_LIST: {
        URL: ENV.ADMIN_API_URL + "/bodyParts",
        METHOD: "get"
    },
    INJURY_TYPE_LIST: {
        URL: ENV.ADMIN_API_URL + "/injuryTypes",
        METHOD: "get"
    },
    PROGRESS_REPORT_STATS_LIST: {
        URL: ENV.ADMIN_API_URL + '/progressStats',
        METHOD: 'get'
    },
    CONCUSSION_FILE_TYPES: {
        URL: ENV.ADMIN_API_URL + '/concussionTypes',
        METHOD: 'get'
    },
    MEDICAL_RECORD_DOCUMENT_TYPES: {
        URL: ENV.ADMIN_API_URL + '/documentTypes',
        METHOD: 'get'
    },
    CASE_STATUS_LIST: {
        URL: ENV.ADMIN_API_URL + '/caseStatus',
        METHOD: 'get'
    },
    PAYMENT_MODES: {
        URL: ENV.ADMIN_API_URL + '/paymentModes',
        METHOD: 'get'
    },
    //meta end
    USER_LIST_LITE: {
        URL: ENV.CUSTOMER_API_URL + "/user/lite",
        METHOD: "get"
    },
    // authentication start
    LOGIN: {
        URL: ENV.CUSTOMER_API_URL + "/login",
        METHOD: "post"
    },
    VERIFY_OTP: {
        URL: ENV.CUSTOMER_API_URL + "/verifyOTP",
        METHOD: "post"
    },
    CHECK_LOGIN: {
        URL: ENV.CUSTOMER_API_URL + "/login",
        METHOD: "get"
    },
    LOGOUT: {
        URL: ENV.CUSTOMER_API_URL + "/login",
        METHOD: "delete"
    },
    SWITCH_PROFILE: {
        URL: (profileId: string) => ENV.CUSTOMER_API_URL + "/switchProfile/" + profileId,
        METHOD: "post"
    },
    // authentication end

    CLIENT_INJURY_DETAILS_SAVE: {
        URL: ENV.CUSTOMER_API_URL + '/injuryForm',
        METHOD: 'post'
    },
    CLIENT_INJURY_DETAILS_UPDATE: {
        URL: (formId: string) => ENV.CUSTOMER_API_URL + '/injuryForm/' + formId,
        METHOD: 'put'
    },
    SAVE_CLIENT_BASIC_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/profile',
        METHOD: 'put'
    },
    GET_CLIENT_BASIC_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/profile',
        METHOD: 'get'
    },
    SAVE_CLIENT_COMMUNICATION_REFERRAL_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/account',
        METHOD: 'put'
    },
    GET_CLIENT_FIRST_INJURY_FORM_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/firstInjuryForm',
        METHOD: 'get'
    },
    GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/account',
        METHOD: 'get'
    },
    GET_CLIENT_MEDICAL_HISTORY_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/medicalQuestionnaire',
        METHOD: 'get'
    },
    SAVE_CLIENT_MEDICAL_PROVIDER_INFO_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/medicalProvider',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_PERSONAL_HABITS_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/personalHabits',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_MEDICATION_SUPPLEMENTS_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/medication',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_QUESTIONNAIRE_ALLERGIES_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/allergies',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_MEDICAL_HISTORY_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/medicalHistory',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_FEMALE_ONLY_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/femaleQuestion',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_SURGICAL_HISTORY_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/surgicalHistory',
        METHOD: 'post'
    },
    SAVE_CLIENT_MEDICAL_HISTORY_MUSCULOSKELETAL_HISTORY_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/musculoskeletalHistory',
        METHOD: 'post'
    },
    SUBMIT_REGISTRATION_CONSENT_FORM: {
        URL: ENV.CUSTOMER_API_URL + '/consentForm',
        METHOD: 'post'
    },
    UPDATE_REGISTRATION_CONSENT_FORM: {
        URL: (formId: string) => ENV.CUSTOMER_API_URL + '/consentForm/' + formId,
        METHOD: 'put'
    },
    GET_MY_APPOINTMENTS: {
        URL: ENV.CUSTOMER_API_URL + '/appointment',
        METHOD: 'get'
    },
    GET_UPCOMING_APPOINTMENT_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/appointment/next',
        METHOD: 'post'
    },
    GET_APPOINTMENT_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + `/appointment/${appointmentId}`,
        METHOD: 'get'
    },
    GET_INJURY_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + `/injuryForm/${appointmentId}`,
        METHOD: 'get'
    },
    GET_CERTIFICATION_AND_CONSENT_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + `/consentForm/${appointmentId}`,
        METHOD: 'get'
    },
    GET_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + `/authorizationRMIForm/${appointmentId}`,
        METHOD: 'get'
    },
    GET_FIRST_AUTHORIZATION_TO_RELEASE_INFORMATION_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + `/firstAuthorizationRMIForm`,
        METHOD: 'get'
    },
    GET_AUTHORIZATION_DISCLOSE: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + `/appointment/${appointmentId}/authorizationToDisclose`,
        METHOD: 'get'
    },
    POST_AUTHORIZATION_DISCLOSE: {
        URL: ENV.CUSTOMER_API_URL + `/authorizationToDisclose`,
        METHOD: 'post'
    },
    APPOINTMENT_STATUS_LIST: {
        URL: ENV.ADMIN_API_URL + '/appointmentStatus',
        METHOD: 'get'
    },
    GET_CASES_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/caseRecords/list',
        METHOD: 'post'
    },
    GET_CASE_DETAIL_LIST: {
        URL: (caseId: string) => ENV.CUSTOMER_API_URL + '/medicalRecord/' + caseId + '/documents',
        METHOD: "get"
    },
    GET_CLIENT_PDF: {
        URL: (caseId: string, documentId: string) => ENV.CUSTOMER_API_URL + '/progressReport/' + caseId + '/generatePDF',
        METHOD: "post"
    },
    GET_CLIENT_CASE_DETAIL: {
        URL: (caseId: string) => ENV.CUSTOMER_API_URL + '/medicalRecord/' + caseId + '/documents',
        METHOD: "get"
    },
    GENERATE_INVOICE: {
        URL: (invoiceId: string) => ENV.CUSTOMER_API_URL + '/invoice/' + invoiceId + '/generatePDF',
        METHOD: "post"
    },
    GENERATE_RECEIPT: {
        URL: (receiptId: string) => ENV.CUSTOMER_API_URL + '/receipt/' + receiptId + '/generatePDF',
        METHOD: "post"
    },
    MAKE_PAYMENT: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/appointment/' + appointmentId + '/payment',
        METHOD: "post"
    },
    GET_AVAILABLE_COUPONS_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/availableCoupons',
        METHOD: "get"
    },
    GET_AVAILABLE_SLOTS: {
        URL: (userId: string, date: string) => ENV.CUSTOMER_API_URL + "/user/" + userId + "/availableTimings?available_on=" + date,
        METHOD: "get"
    },
    RESCHEDULE_APPOINTMENT: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/appointment/' + appointmentId + '/reschedule',
        METHOD: "put"
    },
    CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY: {
        URL: ENV.CUSTOMER_API_URL + '/waiverForm',
        METHOD: 'post'
    },
    GET_CLIENT_WAIVER_AND_RELEASE_OF_LIABILITY: {
        URL: ENV.CUSTOMER_API_URL + '/waiverForm',
        METHOD: 'get'
    },
    ACCESSIBLE_ACCOUNTS: {
        URL: ENV.CUSTOMER_API_URL + '/accessibleAccounts',
        METHOD: "get"
    },
    MY_ACCOUNT_ACCESSORS: {
        URL: ENV.CUSTOMER_API_URL + '/myAccountAccessors',
        METHOD: "get"
    },
    FIND_PROFILE: {
        URL: ENV.CUSTOMER_API_URL + "/findProfile",
        METHOD: "get"
    },
    REQUEST_ACCOUNT_ACCESS: {
        URL: ENV.CUSTOMER_API_URL + '/requestAccess',
        METHOD: "post"
    },
    GRANT_ACCESS_TO_PROFILE: {
        URL: ENV.CUSTOMER_API_URL + '/grantAccess',
        METHOD: "post"
    },
    UNLINK_PROFILE: {
        URL: (profileId: string) => ENV.CUSTOMER_API_URL + '/linkedProfile/' + profileId,
        METHOD: "delete"
    },
    EDIT_PROFILE_LINKING: {
        URL: (profileId: string) => ENV.CUSTOMER_API_URL + '/linkedProfile/' + profileId,
        METHOD: "put"
    },
    APPROVE_REJECT_PROFILE_LINKING: {
        URL: (profileId: string, type: string) => ENV.CUSTOMER_API_URL + '/linkedProfile/' + profileId + '/' + type,
        METHOD: "patch"
    },
    UPDATE_PROFILE_STATUS: {
        URL: (clientId: string) => ENV.CUSTOMER_API_URL + '/client/' + clientId + '/upgrade',
        METHOD: "put"
    },
    EXIT_PROFILE: {
        URL: ENV.CUSTOMER_API_URL + '/exitProfile',
        METHOD: "post"
    },
    CANCEL_REQUESTED_ACCESS: {
        URL: (selectedProfileID: string) => ENV.CUSTOMER_API_URL + '/request/' + selectedProfileID + '/cancel',
        METHOD: "post"
    },
    ADD_NEW_CLIENT: {
        URL: ENV.CUSTOMER_API_URL + '/client',
        METHOD: 'post'
    },
    NEW_CLIENT_REGISTER: {
        URL: ENV.CUSTOMER_API_URL + '/register',
        METHOD: 'post'
    },
    GET_FORM_STATUS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/appointment/' + appointmentId + '/formStatus',
        METHOD: 'get'
    },
    CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION: {
        URL: ENV.CUSTOMER_API_URL + '/authorizationRMIForm',
        METHOD: 'post'
    },
    CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION_UPDATE: {
        URL: (formId: string) => ENV.CUSTOMER_API_URL + '/authorizationRMIForm/' + formId,
        METHOD: 'put'
    },
    GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION: {
        URL: (formId: string) => ENV.CUSTOMER_API_URL + '/authorizationRMIForm/' + formId,
        METHOD: 'get'
    },
    GET_CLIENT_ACTIVITY_LOGS: {
        URL: ENV.CUSTOMER_API_URL + '/activityLog',
        METHOD: 'get'
    },
    PRINT_NOTICE_OF_PRIVACY_PRACTICES: {
        URL: ENV.CUSTOMER_API_URL + '/privacy_notice/generatePDF',
        METHOD: 'post'
    },

    PRINT_WAIVER_AND_RELEASE_OF_LIABILITY: {
        URL: ENV.CUSTOMER_API_URL + '/waiver_and_liability/generatePDF',
        METHOD: 'post'
    },
    PRINT_ATTENDANCE_POLICY: {
        URL: ENV.CUSTOMER_API_URL + '/attendance_policy/generatePDF',
        METHOD: 'post'
    },
    PRINT_NEW_INJURY_FORM: {
        URL: (formId: string) => ENV.CUSTOMER_API_URL + '/injuryForm/' + formId + '/generatePDF',
        METHOD: 'post'
    },
    PRINT_AUTHORIZATION_TO_RELEASE_INFORMATION: {
        URL: ENV.CUSTOMER_API_URL + '/authorizationRMIForm/generatePDF',
        METHOD: 'post'
    },
    GET_CLIENT_DOCUMENT: {
        URL: (caseId: string, documentId: string) => ENV.CUSTOMER_API_URL + '/medicalRecord/' + caseId + '/document/' + documentId + '/generatePDF',
        METHOD: 'post'
    },
    GET_CLIENT_SIGNATURE_DETAILS: {
        URL: (is_onboarded_certification: boolean, initial_appointment_id?: string) => ENV.CUSTOMER_API_URL + `/signature?appointment_id=${initial_appointment_id}`,
        METHOD: 'get'
    },
    ADD_PHYSICAL_ACTIVITY_QUESTIONNAIRE: {
        URL: ENV.CUSTOMER_API_URL + '/PhysicalActivityQuestionnaireForm',
        METHOD: 'post'
    },
    GET_PHYSICAL_ACTIVITY_QUESTIONNAIRE: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/appointment/' + appointmentId + '/PhysicalActivityQuestionnaireForm',
        METHOD: 'get'
    },
    GET_REQUEST_ACCESS_DETAILS: {
        URL: (requestId: string) => ENV.CUSTOMER_API_URL + '/request/' + requestId,
        METHOD: 'get'
    },
    REJECT_REQUEST: {
        URL: (profileId: string) => ENV.CUSTOMER_API_URL + '/linkedProfile/' + profileId + '/reject',
        METHOD: 'patch'
    },
    APPROVE_REQUEST: {
        URL: (profileId: string) => ENV.CUSTOMER_API_URL + '/linkedProfile/' + profileId + '/approve',
        METHOD: 'patch'
    },
    ATTENDANCE_AND_PRIVACY_POLICY: {
        URL: ENV.CUSTOMER_API_URL + '/privacyAndAttendancePolicyForm',
        METHOD: 'post'
    },
    GET_ALL_SERVICE_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/service',
        METHOD: 'get'
    },
    OTHER_SHARE_DOCUMENTS: {
        URL: ENV.CUSTOMER_API_URL + '/caseRecords/otherDocuments',
        METHOD: 'post'
    },
    GET_FACILITY_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/facility',
        METHOD: 'get'
    },

    //Book Appointment Flow Apis Configs
    GET_FACILITY_WITH_PROVIDERS_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/facilityWithProviders',
        METHOD: 'get'
    },
    GET_FACILITY_DETAILS: {
        URL: (facilityId: string) => ENV.CUSTOMER_API_URL + `/facility/${facilityId}`,
        METHOD: 'get'
    },
    GET_SERVICE_CATEGORY_DETAILS: {
        URL: (facilityId: string) => ENV.CUSTOMER_API_URL + `/facility/${facilityId}/getCategories`,
        METHOD: 'get'
    },
    GET_PROVIDER_DETAILS: {
        URL: (providerId: string) => ENV.CUSTOMER_API_URL + `/provider/${providerId}/view`,
        METHOD: 'get'
    },
    GET_SERVICE_LIST: {
        URL: (facilityId: string, categoryId: string) => ENV.CUSTOMER_API_URL + `/facility/${facilityId}/category/${categoryId}/getServices`,
        METHOD: 'get'
    },
    GET_PROVIDER_AVAILABLE_DATES: {
        URL: (providerId: string) => ENV.CUSTOMER_API_URL + `/user/${providerId}/availableDates`,
        METHOD: 'get'
    },
    GET_PROVIDER_AVAILABLE_TIMINGS: {
        URL: (providerId: string) => ENV.CUSTOMER_API_URL + `/user/${providerId}/availableTimings`,
        METHOD: 'get'
    },
    GET_CASE_LIST_LITE_API_CONFIG: {
        URL: (clientId: string) => ENV.CUSTOMER_API_URL + `/client/${clientId}/medical/listLite`,
        METHOD: 'get'
    },
    APPLY_COUPON_BOOK_APPOINTMENT: {
        URL: ENV.CUSTOMER_API_URL + '/coupon/validate/single',
        METHOD: 'post'
    },
    BLOCK_THE_SLOT: {
        URL: ENV.CUSTOMER_API_URL + '/slot/block',
        METHOD: 'post'
    },

    UNBLOCK_THE_SLOT: {
        URL: ENV.CUSTOMER_API_URL + '/slot/unblock',
        METHOD: 'post'
    },

    UNBLOCK_MULTIPLE_THE_SLOT: {
        URL: ENV.CUSTOMER_API_URL + '/slot/unblock/multiple',
        METHOD: 'post'
    },

    BOOK_APPOINTMENT_POST: {
        URL: ENV.CUSTOMER_API_URL + '/appointment',
        METHOD: 'post'
    },

    APPOINTMENT_PAYMENT_API: {
        URL: ENV.CUSTOMER_API_URL + `/appointments/pay`,
        METHOD: 'post'
    },

    PROVIDER_LIST_CATEGORY_FACILITY_BASED: {
        URL: (facilityId: string, categoryId: string) => ENV.CUSTOMER_API_URL + `/facility/${facilityId}/${categoryId}/getProviders`,
        METHOD: 'get'
    },

    //Performance and Medical Record Flow Apis
    GET_MEDICAL_RECORD_DETAILS: {
        URL: (medicalRecordId: string) => ENV.CUSTOMER_API_URL + '/medicalRecord/' + medicalRecordId,
        METHOD: 'get'
    },
    GET_MEDICAL_RECORD_SHARED_DOCUMENTS_LIST: {
        URL: (medicalRecordId: string) => ENV.CUSTOMER_API_URL + '/medicalRecord/' + medicalRecordId + '/documents',
        METHOD: 'post'
    },
    GET_PERFORMANCE_RECORD_DETAILS: {
        URL: (performanceRecordId: string) => ENV.CUSTOMER_API_URL + '/performanceRecord/' + performanceRecordId,
        METHOD: 'get'
    },
    GET_PERFORMANCE_RECORD_DOCUMENTS_LIST: {
        URL: (performanceRecordId: string) => ENV.CUSTOMER_API_URL + '/performanceRecord/' + performanceRecordId + '/documents',
        METHOD: 'post'
    },
    GET_PENDING_PAYMENT_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/invoice/list',
        METHOD: 'post'
    },
    GET_COMPLETED_PAYMENT_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/receipt/list',
        METHOD: 'post'
    },
    GET_INVOICE_DETAILS: {
        URL: (invoiceId: string) => ENV.CUSTOMER_API_URL + '/invoice/' + invoiceId,
        METHOD: 'get'
    },
    GET_RECEIPT_DETAILS: {
        URL: (receiptId: string) => ENV.CUSTOMER_API_URL + '/receipt/' + receiptId,
        METHOD: 'get'
    },
    VERIFY_COUPON: {
        URL: ENV.CUSTOMER_API_URL + '/coupon/validate/single',
        METHOD: 'post'
    },
    INVOICE_PAYMENT: {
        URL: (invoiceId: string) => ENV.CUSTOMER_API_URL + '/invoice/' + invoiceId + '/pay',
        METHOD: 'put'
    },
    GET_REQUEST_COUNT: {
        URL: ENV.CUSTOMER_API_URL + '/pendingRequests',
        METHOD: 'get'
    },
    GET_ALL_7_APPOINTMENTS: {
        URL: ENV.CUSTOMER_API_URL + '/dashboard/getUpcomingAppointments',
        METHOD: 'get'
    },
    GET_ALL_APPOINTMENTS: {
        URL: ENV.CUSTOMER_API_URL + '/appointment',
        METHOD: 'get'
    },
    GET_SCHEDULED_OUTSTANDING_AMOUNT_COUNT: {
        URL: ENV.CUSTOMER_API_URL + '/dashboard/getScheduledAppointmentsAndOutstandingAmount',
        METHOD: 'get'
    },
    GET_ALL_ALERTS_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/dashboard/getAlerts',
        METHOD: 'get'
    },
    SYSTEM_SETTINGS_DETAILS: {
        URL: ENV.CUSTOMER_API_URL + '/systemSetting',
        METHOD: 'get'
    },
    DASHBOARD_FORM_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/waiverAndAuthorizationForms/list',
        METHOD: 'get'
    },
    GET_CASES_LIST_LITE: {
        URL: ENV.CUSTOMER_API_URL + '/caseRecords/lite',
        METHOD: 'get'
    },
    ADD_WAIVER_RELEASE_FORM: {
        URL: ENV.CUSTOMER_API_URL + '/waiverForm',
        METHOD: 'post'
    },
    WAIVER_RELEASE_FORM: {
        URL: (id: string) => ENV.CUSTOMER_API_URL + '/waiverForm/' + id,
        METHOD: 'put'
    },
    AUTHORIZATION_CASES_LIST: {
        URL: ENV.CUSTOMER_API_URL + '/caseRecords/lite',
        METHOD: 'get'
    },
    ADD_AUTHORISATION_TO_DISCLOSE_INFORMATION: {
        URL: ENV.CUSTOMER_API_URL + '/authorizationToDisclose',
        METHOD: 'post'
    },
    EDIT_AUTHORISATION_TO_DISCLOSE_INFORMATION: {
        URL:(id: string)=> ENV.CUSTOMER_API_URL + '/authorizationToDisclose/'+ id,
        METHOD: 'put'
    },
    GET_AUTHORISATION_TO_DISCLOSE_INFORMATION_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/appointment/' + appointmentId + '/authorizationToDisclose',
        METHOD: 'get'
    },
    ADD_AUTHORISATION_TO_HEALTH_INFORMATION: {
        URL: ENV.CUSTOMER_API_URL + '/authorizationToRelease',
        METHOD: 'post'
    },
    EDIT_AUTHORISATION_TO_HEALTH_INFORMATION: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/authorizationToRelease/' + appointmentId,
        METHOD: 'put'
    },
    GET_AUTHORISATION_TO_HEALTH_INFORMATION_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/authorizationToRelease/' + appointmentId,
        METHOD: 'get'
    },
    EDIT_AUTHORISATION_TO_HEALTH_INFORMATION_DETAILS: {
        URL: (appointmentId: string) => ENV.CUSTOMER_API_URL + '/authorizationToRelease/' + appointmentId,
        METHOD: 'post'
    }
}

export default APIConfig;
